import React, { Component } from "react";

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        style={{
          margin: "auto",
          maxWidth: "600px",
          padding: "20px",
        }}
      >
        <h1>Contact</h1>
        <div>
          <div>Name: Audiblogs Inc</div>
          <div>Contact: Eric Jung, jazz302098@gmail.com (or eric@audiblogs.com)</div>
          <div>Address: 1040 Folsom Street, San Francisco, CA 94103</div>
        </div>
      </div>
    );
  }
}

export default About;
